import React from 'react';
import { useFetchNotifications } from './hooks';
import type { NotificationContextValue } from '~/dashboard/context';
import { NotificationsContext } from '~/dashboard/context';

export const NotificationsProvider = ({
  children,
  isAuthenticated,
}: {
  children: React.ReactNode;
  isAuthenticated: boolean; }) => {
  const notificationContext: NotificationContextValue = useFetchNotifications({ isAuthenticated });

  return (
    <NotificationsContext.Provider value={notificationContext}>
      {children}
    </NotificationsContext.Provider>
  );
};
